import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../components/minimal-layout';
export const _frontmatter = {
  "title": ""
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Blocks UI (alpha)`}</h1>
    <p><strong parentName="p">{`⚠️ Currently under development`}</strong></p>
    <p>{`A JSX-based page builder for creating beautiful websites without writing
code. Blocks comes with built-in components that are carefully designed
and implemented with `}<a parentName="p" {...{
        "href": "https://theme-ui.com"
      }}>{`Theme UI`}</a>{`.`}</p>
    <p>{`The editor reads and writes production-ready React code, making it an
innovative tool for teams.`}</p>
    <p>{`It's open source and MIT licensed.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/demo"
        }}>{`Try the demo `}{`→`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/getting-started"
        }}>{`Read the docs `}{`→`}</a></li>
    </ul>
    <br />
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/1424573/69644337-c13a2580-1021-11ea-8c76-379386372db1.gif",
        "alt": "Blocks demo"
      }}></img></p>
    <br />
    <h2>{`Stay in the loop`}</h2>
    <p>{`Blocks is a work in progress with a quick release cycle. If you'd like to contribute
with development, design, or report bugs`}{`—`}{`join in on
`}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://github.com/blocks"
        }}>{`GitHub`}</a></strong>{`.
If you want to stay in the know about new features follow us on
`}<strong parentName="p"><a parentName="strong" {...{
          "href": "https://twitter.com/blocks_ui"
        }}>{`Twitter`}</a></strong>{`.`}</p>
    <p>{`If you want news delivered to your inbox, `}<strong parentName="p"><a parentName="strong" {...{
          "href": "/newsletter"
        }}>{`subscribe to the newsletter `}{`→`}</a></strong></p>
    <br /><br />
    <hr></hr>
    <br />
    <p style={{
      color: '#444',
      fontSize: 16
    }}>
      <b>⚠️</b>
      <em style={{
        marginLeft: 8
      }}>
Blocks is currently in early alpha and only supports a constrained
subset of JSX source code. We plan on continually adding support for
more and more variations in code.
      </em>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      